import React from "react";
import { Route, Routes } from "react-router-dom";
import { ROUTES } from "./url-constant";
import Dashboard from "../pages/page/dashboard";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "../pages/auth/login";
import Forgetpassword from "../pages/auth/forgetpassword";
import RessetPassword from "../pages/auth/ressetPassword";
import AdminLayout from "../components/layout/adminLayout";
import RoleManegment from "../pages/page/role-manegment";
import EmployeeTable from "../pages/page/EmployeeTAble";
import AdminProtectedRoute from "./adminProtectedRoute";
import AddRole from "../pages/page/AddRole";
import Model from "../components/common/Model";
import AddEmployee from "../pages/page/AddEmployee";
import AddCriteria from "../pages/page/AddCriteria";
import CompanyManagement from "../pages/page/CompanyManagement";
import CompanyEmployeeManagement from "../pages/page/CompanyEmployeeManagement";
import AddComapnyEmployee from "../pages/page/AddCompanyEmployee";
import AddComapny from "../pages/page/AddCompany";
import IndivisualResult from "../../user/pages/page/IndivisualResult";
import OverallResult from "../../user/pages/page/OverallResult";
import AddOnsiteManagement from "../pages/page/AddOnsiteAssessment";
import OnSiteAssessment from "../pages/page/OnSiteAssessment"
import AdminProfile from "../pages/page/AdminProfile";
import AddOnSiteScore from "../pages/page/AddOnSiteScore";
import AdminChangePassword from "../pages/auth/AdminChangePassword";
import ModalManagement from "../pages/page/ModalManagement";
import DimensionsManagement from "../pages/page/DimensionsManagement";
import SubDimenstionManagement from "../pages/page/SubDimenstionManagement";
import CriteriaManagement from "../pages/page/CriteriaManagement";
import AddAssignedAssesments from "../pages/page/AddAssignedAssesments";
import ViewAssimentUser from "../pages/page/viewAssimentCompnay";
import AssignEmployeeByCompanyId from "../pages/page/assignEmployeeByCompanyId";
import FirstTimeChangePass from "../pages/auth/firstTimeChangePass";
import AdminAppLogout from "./adminAppLogout";
import GraphOverallResult from "../../user/pages/page/GraphOverallResult";
import GraphDetail from "../../user/pages/page/GraphDetail";
import ComapnyWiseUserResult from "../pages/page/ComapnyWiseUserResult";
import BulkUpload from "../pages/page/BulkUpload";
import NewResult from "../../newresult/NewResult";
import EmployeeBulkUpload from "../pages/page/EmployeeBulkUpload";
import IndivisualResultNew from "../../user/pages/page/IndivisualResultNew";
import AssessorList from "../pages/page/AssessormanagementList";
import AddAssignedAssessor from "../pages/page/AddAssignedAssessor";

const RouteData = () => {
  return (
    <div>
      <Routes>
        <Route index element={<Login />} />
        <Route path={ROUTES.ADMINLOGINPAGE} element={<Login />} />
        <Route path={ROUTES.FORGOTPASSWORD} element={<Forgetpassword />} />
        <Route path={ROUTES.RESETPASSWORD} element={<RessetPassword />} />
        <Route
          path={ROUTES.FIRSTTIMECHANGESPASS}
          element={<AdminProtectedRoute component={<FirstTimeChangePass />} />}
        />
        <Route element={<AdminLayout />}>

          <Route
            path={ROUTES.DASHBOARD}
            element={<AdminProtectedRoute component={<AdminAppLogout><Dashboard /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.MODALTABLE}
            element={<AdminProtectedRoute component={<AdminAppLogout><ModalManagement /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.DIMENSIONTABLE}
            element={<AdminProtectedRoute component={<AdminAppLogout><DimensionsManagement /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.SUBDIMENSIONTABLE}
            element={<AdminProtectedRoute component={<AdminAppLogout><SubDimenstionManagement /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.CRITERIATABLE}
            element={<AdminProtectedRoute component={<AdminAppLogout><CriteriaManagement /></AdminAppLogout>} />}
          />
         {/*bulk upload */}
          <Route
            path={ROUTES.BULKUPLOAD}
            element={<AdminProtectedRoute component={<AdminAppLogout><BulkUpload /></AdminAppLogout>} />}
          />
           <Route
            path={ROUTES.EMPLOYEEBULKUPLOAD}
            element={<AdminProtectedRoute component={<AdminAppLogout><EmployeeBulkUpload /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.ADMINROLE}
            element={<AdminProtectedRoute component={<AdminAppLogout><RoleManegment /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.EMPLOYEEMANAGEMENT}
            element={<AdminProtectedRoute component={<AdminAppLogout><EmployeeTable /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.ADDROLE}
            element={<AdminProtectedRoute component={<AdminAppLogout><AddRole /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.ADDEMPLOYEE}
            element={<AdminProtectedRoute component={<AdminAppLogout><AddEmployee /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.ADDCRITERIA}
            element={<AdminProtectedRoute component={<AdminAppLogout><AddCriteria /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.COMPANYMANAGEMENT}
            element={<AdminProtectedRoute component={<AdminAppLogout><CompanyManagement /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.COMPANYEMPLOYEEMANAGEMENT}
            element={<AdminProtectedRoute component={<AdminAppLogout><CompanyEmployeeManagement /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.ADDCOMPANY}
            element={<AdminProtectedRoute component={<AdminAppLogout><AddComapny /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.VIEWUSERWISERESULT}
            element={<AdminProtectedRoute component={<AdminAppLogout><ComapnyWiseUserResult /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.ADDCOMPANYEMLOYEE}
            element={<AdminProtectedRoute component={<AdminAppLogout><AddComapnyEmployee /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.ONSITE}
            element={<AdminProtectedRoute component={<AdminAppLogout><OnSiteAssessment /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.ADDONSITE}
            element={<AdminProtectedRoute component={<AdminAppLogout><AddOnsiteManagement /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.ADMINPROFILE}
            element={<AdminProtectedRoute component={<AdminAppLogout><AdminProfile /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.ADMINCHANGEPASSWORD}
            element={<AdminProtectedRoute component={<AdminAppLogout><AdminChangePassword /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.MODEL}
            element={<AdminProtectedRoute component={<AdminAppLogout><Model /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.INDIVISUALRESULT}
            element={<AdminProtectedRoute component={<AdminAppLogout><IndivisualResultNew /></AdminAppLogout>} />}
          />
           <Route
            path={ROUTES.ASSESSORMANAGEMENT}
            element={<AdminProtectedRoute component={<AdminAppLogout><AssessorList /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.ADDASSESSORMANAGEMENT}
            element={<AdminProtectedRoute component={<AdminAppLogout><AddAssignedAssessor /></AdminAppLogout>} />}
          />
           {/* <Route
            path={ROUTES.INDIVISUALRESULTNEW}
            element={<AdminProtectedRoute component={<AdminAppLogout><IndivisualResultNew /></AdminAppLogout>} />}
          /> */}
          {/* <Route
            path={ROUTES.OVERALLRESULT}
            element={<AdminProtectedRoute component={<AdminAppLogout><OverallResult selectedCompanyId={1} companyList={[]} handleSelect={() => { }} /></AdminAppLogout>} />}
          /> */}
          <Route
            path={ROUTES.GRAPHDETAIL}
            element={<AdminProtectedRoute component={<AdminAppLogout><GraphDetail selectedCompanyId={1} companyList={[]} handleSelect={() => { }} /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.OVERALLRESULT}
            element={<AdminProtectedRoute component={<AdminAppLogout><GraphOverallResult selectedCompanyId={1} companyList={[]} handleSelect={() => { }} /></AdminAppLogout>} />}
          />
           <Route
            path={ROUTES.NEWRESULT}
            element={<AdminProtectedRoute component={<AdminAppLogout><NewResult selectedCompanyId={1} companyList={[]} handleSelect={() => { }} /></AdminAppLogout>} />}
          />

          <Route
            path={ROUTES.ADDASSIGNEDASSESSMENTS}
            element={<AdminProtectedRoute component={<AdminAppLogout><AddAssignedAssesments /></AdminAppLogout>} />}
          />
          <Route
            path={ROUTES.VIEWASSIGNEDASSESSMENTS}
            element={<AdminProtectedRoute component={<AdminAppLogout><ViewAssimentUser /></AdminAppLogout>} />}
          />

          <Route
            path={ROUTES.VIEWASSIGNEDEBYCOMPNYID}
            element={<AdminProtectedRoute component={<AdminAppLogout><AssignEmployeeByCompanyId /></AdminAppLogout>} />}
          />
          
        </Route>
        <Route
          path={ROUTES.ONSITESCORE}
          element={<AdminProtectedRoute component={<AdminAppLogout><AddOnSiteScore /></AdminAppLogout>} />}
        />

      </Routes>
      <ToastContainer />
    </div>
  );
};

export default RouteData;
